import { Utils } from '@pacem/pacem-core';
export const PermissionEditEventName = 'permissionedit';
export class PermissionEditEvent extends CustomEvent {
    constructor(permissible) {
        super(PermissionEditEventName, { detail: permissible, cancelable: false, bubbles: true });
    }
}
export class Permissible {
    static canEdit(claims, resource) { return this._canDoSomethingToResource(claims, resource, p => p.update); }
    static canRead(claims, resource) { return this._canDoSomethingToResource(claims, resource, p => p.read); }
    static canAdd(claims, resource) { return this._canDoSomethingToResource(claims, resource, p => p.create); }
    static canDelete(claims, resource) { return this._canDoSomethingToResource(claims, resource, p => p.delete); }
    static canTranslate(claims, resource) { return this._canDoSomethingToResource(claims, resource, p => p.translate); }
    static _canDoSomethingToResource(claims, resource, predicate) {
        if (Utils.isNullOrEmpty(claims) || Utils.isNull(resource)) {
            return false;
        }
        // if no permissions are set, then you're free to go!
        var editable = true;
        if (resource.permissions && resource.permissions.length > 0) {
            // check correspondence otherwise
            editable = false;
            for (let permission of resource.permissions) {
                if (predicate(permission) && claims[permission.claimType] && claims[permission.claimType].indexOf(permission.claimValue) >= 0) {
                    return true;
                }
            }
        }
        // return
        return editable;
    }
}
